
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

import moment from "moment"

import vSelect from "vue-select"
import Numeric from "@/components/Fields/Numeric.vue"

import { Schedule, ScheduleFreq, ScheduleFreqLabels, DayOfWeek, DayOfWeekLabels, DayOfMonth } from "@/types/schedule"

@Component({
	components: {
		numeric: Numeric,
		"v-select": vSelect
	}
})
export default class ScheduleControl extends Vue {
	@Prop()
	value!: Schedule;

	private scheduleFreq = ScheduleFreq
	private scheduleFreqOptions = ScheduleFreqLabels

	get daysOfWeek () {
		const days = [0, 1, 2, 3, 4, 5, 6]
		return days.map(day => {
			return {
				key: day,
				label: moment.weekdays(day)
			}
		})
	}

	public mounted () {
	}
}

